import { render } from "./MainDashAgro.vue?vue&type=template&id=21150eed&scoped=true"
import script from "./MainDashAgro.vue?vue&type=script&lang=js"
export * from "./MainDashAgro.vue?vue&type=script&lang=js"

import "./MainDashAgro.vue?vue&type=style&index=0&id=21150eed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21150eed"]])

export default __exports__